<template>
  <div class="atp" role="radiogroup" :aria-label="label">
    <div class="atp__head">
      <p class="atp__label">{{ label }}</p>
      <p v-if="hint" class="atp__hint">{{ hint }}</p>
    </div>

    <div class="atp__grid">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="atp__card"
        :class="{
          'atp__card--active': modelValue === option.value,
          [`atp__card--${option.tone}`]: true,
        }"
        :aria-pressed="modelValue === option.value"
        :disabled="disabled"
        @click="select(option.value)"
      >
        <span class="atp__icon" :class="`atp__icon--${option.tone}`">
          <v-icon :icon="option.icon" size="20" />
        </span>
        <span class="atp__title">{{ option.title }}</span>
        <span class="atp__subtitle">{{ option.subtitle }}</span>
        <span v-if="modelValue === option.value" class="atp__check" aria-hidden="true">
          <v-icon icon="mdi-check-circle" size="16" />
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { AGENT_TYPE_OPTIONS } from '@/utils/orgUsers'
import '@/styles/users/agent-type-picker.css'

defineOptions({ name: 'AgentTypePicker' })

defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: 'Member type' },
  hint: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  options: { type: Array, default: () => AGENT_TYPE_OPTIONS },
})

const emit = defineEmits(['update:modelValue'])

function select(value) {
  emit('update:modelValue', value)
}
</script>
